export const AUD_MOBILE_REDESIGN_MAINPAGE_HEADER = 'aud_mobile_bx925_redesign_mainpage_header';
export const PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT = 'aud_desktop_bx775_saved_search_favorites_merge';

export const EXPERIMENTS = [AUD_MOBILE_REDESIGN_MAINPAGE_HEADER, PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT];
